export const appPaths = {
  home: "",
  error404: "404",
  auth: "auth",
};

export const appRoutes = {
  home: `/${appPaths.home}`,
  error404: `/${appPaths.error404}`,
};
